export default "__VITE_ASSET__ByGCqm0p__"